/** Plain `{}` objects only — leaves Date, File and the like untouched. */
function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== 'object') {
    return false;
  }
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

/**
 * Drops blank string fields — the API rejects them on optional fields.
 * Top level only, so add-to-cart's raw provider offer goes back untouched.
 * Keeps `null`; some endpoints read it as "no value set".
 */
export function withoutEmptyStrings<T>(body: T): T {
  if (!isPlainObject(body)) {
    return body;
  }

  const cleaned: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(body)) {
    if (typeof value === 'string' && value.trim() === '') {
      continue;
    }
    cleaned[key] = value;
  }

  return cleaned as T;
}
